// Classes jouables (miroir de backend/config/dofusClasses.js), libellés français par défaut
export const DOFUS_CLASSES = [
    { key: 'feca', label: 'Féca' },
    { key: 'osamodas', label: 'Osamodas' },
    { key: 'enutrof', label: 'Enutrof' },
    { key: 'sram', label: 'Sram' },
    { key: 'xelor', label: 'Xélor' },
    { key: 'ecaflip', label: 'Ecaflip' },
    { key: 'eniripsa', label: 'Eniripsa' },
    { key: 'iop', label: 'Iop' },
    { key: 'cra', label: 'Crâ' },
    { key: 'sadida', label: 'Sadida' },
    { key: 'sacrieur', label: 'Sacrieur' },
    { key: 'pandawa', label: 'Pandawa' },
    { key: 'roublard', label: 'Roublard' },
    { key: 'zobal', label: 'Zobal' },
    { key: 'steamer', label: 'Steamer' },
    { key: 'eliotrope', label: 'Eliotrope' },
    { key: 'huppermage', label: 'Huppermage' },
    { key: 'ouginak', label: 'Ouginak' },
    { key: 'forgelance', label: 'Forgelance' }
];

/** Libellé traduit d'une classe ('' si aucune). */
export const classLabel = (t, key) => {
    const found = DOFUS_CLASSES.find(c => c.key === key);
    return found ? t(`classes.${key}`, found.label) : '';
};
